import axios from 'axios';

export default{
  //  重点设备
  //重点设备保存
  saveStress(data) {
    return axios.post('/dev/stress/save',data);
  },
  //获取重点设备
  getStress(data) {
    return axios.get('/dev/stress/list2',data);
  },
  //获取重点设备详情
  getStressDetails(id) {
    return axios.get('/dev/stress/info/'+id);
  },
  //删除重点设备
  delStress(data) {
    return axios.post('/dev/stress/delete',data);
  },

  
  //  新装设备
  //新装设备保存
  saveNewDev(data) {
    return axios.post('/dev/fresh/save',data);
  },
  //获取新装设备
  getNewDev() {
    return axios.get('/dev/fresh/list2');
  },
  //获取新装设备详情
  getNewDevDetails(id) {
    return axios.get('/dev/fresh/info/'+id);
  },
  //删除新装设备
  delNewDev(data) {
    return axios.post('/dev/fresh/delete',data);
  },



  //  设备状态
  //设备状态保存
  saveState(data) {
    return axios.post('/dev/state/save',data);
  },
  //获取设备状态
  getState() {
    return axios.get('/dev/state/list2');
  },


  //  实时状态
  //实时状态保存
  saveConfig(data) {
    return axios.post('/dev/conf/save',data);
  },
  //获取实时状态
  getConfig() {
    return axios.get('/dev/conf/list');
  },


  //  运行记录
  //运行记录保存
  saveRecord(data) {
    return axios.post('/dev/record/save',data);
  },
  //获取运行记录
  getRecord(data) {
    return axios.get('/dev/record/list',data);
  },
  //删除运行记录
  delRecord(data) {
    return axios.post('/dev/record/delete',data);
  },
  //删除运行记录列表
  delRecordList(data) {
    return axios.post('/dev/record/deleteRecord',data);
  },




  //  物联网设备
  //物联网设备保存
  saveIot(data) {
    return axios.post('/dev/iot/save',data);
  },
  //获取物联网设备
  getIot() {
    return axios.get('/dev/iot/group');
  },




  //  运行提示
  //运行提示保存
  savePrompt(data) {
    return axios.post('/dev/prompt/save',data);
  },
  //获取运行提示
  getPrompt() {
    return axios.get('/dev/prompt/list2');
  },
  //获取运行提示详情
  getPromptDetails(id) {
    return axios.get('/dev/prompt/info/'+id);
  },
  //删除运行提示
  delPrompt(data) {
    return axios.post('/dev/prompt/delete',data);
  },



  
  //  运维团队
  //运维团队保存
  saveOpsTeam(data) {
    return axios.post('/dev/opsTeam/save',data);
  },
  //获取运维团队
  getOpsTeam() {
    return axios.get('/dev/opsTeam/listTree');
  },
  //删除运维团队
  delOpsTeam(data) {
    return axios.post('/dev/opsTeam/delete',data);
  },
  //删除运维团队
  delOpslist2(data) {
    return axios.get('/dev/opsTeam/list2',data);
  },






  
  //  检修计划
  //检修计划保存
  saveInspect(data) {
    return axios.post('/dev/inspect/save',data);
  },
  //获取检修计划
  getInspect() {
    return axios.get('/dev/inspect/list2');
  },
  //删除检修计划
  delInspect(data) {
    return axios.post('/dev/inspect/delete',data);
  },


  
  //  备件更换率
  //备件更换率保存
  saveSpare(data) {
    return axios.post('/dev/spare/save',data);
  },
  //获取备件更换率
  getSpare() {
    return axios.get('/dev/spare/list');
  },
  //删除更换率
  delSpare(data) {
    return axios.post('/dev/spare/delete',data);
  },
}